import { useCallback, useState } from 'react'
import { NUMBER_OF_ITEMS_PER_PAGE } from '../constants'

export type UsePaginationOptions = {
  initialPage?: number
  limit?: number
}

export type PaginationTableProps = {
  currentPage: number
  pageLimit: number
  onPageChange: (page: number) => void
}

export type UsePaginationReturn = {
  page: number
  limit: number
  setPage: (page: number) => void
  reset: () => void
  tableProps: PaginationTableProps
}

export const usePagination = ({
  initialPage = 1,
  limit = NUMBER_OF_ITEMS_PER_PAGE,
}: UsePaginationOptions = {}): UsePaginationReturn => {
  const [page, setPage] = useState(initialPage)

  const reset = useCallback(() => setPage(initialPage), [initialPage])

  return {
    page,
    limit,
    setPage,
    reset,
    tableProps: {
      currentPage: page,
      pageLimit: limit,
      onPageChange: setPage,
    },
  }
}
